import { Link } from "react-router-dom";
import { LogoMark } from "./Navbar";

export default function Footer() {
  return (
    <footer className="bg-[#0B0D0C] border-t hairline" data-testid="site-footer">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <LogoMark />
              <span className="font-display font-bold tracking-[0.18em] text-sm">FAIRLUME</span>
            </div>
            <p className="text-muted-green text-sm leading-relaxed max-w-sm">
              A modern commercial lighting solutions company helping golf courses, sports
              facilities, and large properties make more of their grounds through efficient,
              thoughtfully planned illumination.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-mono-tech text-xs uppercase tracking-[0.25em] text-soft mb-5">Solutions</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/solutions/golf-course-lighting" className="text-white/60 hover:text-white transition-colors" data-testid="footer-link-golf">Golf Course Lighting</Link></li>
              <li><Link to="/solutions/driving-range-lighting" className="text-white/60 hover:text-white transition-colors" data-testid="footer-link-range">Driving Range Lighting</Link></li>
              <li><Link to="/solutions/sports-lighting" className="text-white/60 hover:text-white transition-colors" data-testid="footer-link-sports">Sports Facility Lighting</Link></li>
              <li><Link to="/solutions/commercial-lighting" className="text-white/60 hover:text-white transition-colors" data-testid="footer-link-commercial">Commercial Outdoor Lighting</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-mono-tech text-xs uppercase tracking-[0.25em] text-soft mb-5">Contact</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li data-testid="footer-email">
                <a href="mailto:fairlumeinfo@gmail.com" className="hover:text-white transition-colors">fairlumeinfo@gmail.com</a>
              </li>
              <li data-testid="footer-phone">
                <a href="tel:+14809530059" className="hover:text-white transition-colors">+1 (480) 953-0059</a>
              </li>
              <li data-testid="footer-location">Gilbert, Arizona — serving Arizona &amp; nationwide</li>
            </ul>
            <div className="mt-6 flex gap-6 text-xs text-white/40">
              <Link to="/privacy" className="hover:text-white/70 transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white/70 transition-colors" data-testid="footer-terms">Terms of Use</Link>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t hairline flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/30">
          <span>© {new Date().getFullYear()} Fairlume LLC. All rights reserved.</span>
          <span>Commercial Lighting Solutions — Gilbert, AZ &amp; Nationwide</span>
        </div>
      </div>
    </footer>
  );
}
